if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      //  Add to cart event
        onSubmitHandler(evt) {

          console.log("submit")
          evt.preventDefault();
          const text1 = this.form.querySelector('#silicone-text-1')?.value.trim();
          const text2 = this.form.querySelector('#silicone-text-2')?.value.trim();

          console.log(text1)
          console.log(text2)

          if (!text1 || !text2) {
            alert("Please fill in both text fields before adding to cart.");
            return; // stop submission
          }

          if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

          this.handleErrorMessage();

          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.querySelector('.loading__spinner').classList.remove('hidden');

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData(this.form);

          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }

          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                }).then(() => {
                  CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      CartPerformance.measure("add:paint-updated-sections", () => {
                        this.cart.renderContents(response);
                      });
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                CartPerformance.measure("add:paint-updated-sections", () => {
                  this.cart.renderContents(response);
                });
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');

              CartPerformance.measureFromEvent("add:user-action", evt);
            });
        }

      //  Handle error
        handleErrorMessage(errorMessage = false) {
          if (this.hideErrors) return;

          this.errorMessageWrapper =
            this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
          if (!this.errorMessageWrapper) return;
          this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

          if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }
        }


      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

    }
  );

  // Custom Icons Keyboard Click Event
    let lastFocusedInput = null;

    // Track which input was last focused
    document.getElementById('silicone-text-1').addEventListener('focus', function() {
      lastFocusedInput = this;
    });
    document.getElementById('silicone-text-2').addEventListener('focus', function() {
      lastFocusedInput = this;
    });

    // Utility function to enforce max length and flash red
    function enforceMaxLength(input) {
      if (input.value.length > 16) {
        input.value = input.value.slice(0, 16); // trim extra

        input.style.color = "red"; // flash red
        setTimeout(() => {
          input.style.color = ""; // reset to default (black or inherited)
        }, 200);
      } else {
        input.style.color = ""; // always reset if ≤16
      }
    }

    // Handle button clicks
    document.querySelectorAll('#medical-icons-keyboard button, #fun-icons-keyboard button').forEach(button => {
      button.addEventListener('click', function (event) {
        event.preventDefault(); // stop other button events

        const input1 = document.getElementById('silicone-text-1');
        const value = this.textContent;

        if (lastFocusedInput) {
          lastFocusedInput.value += value;
          enforceMaxLength(lastFocusedInput);
          lastFocusedInput.focus();
        } else {
          input1.focus();
          input1.value += value;
          enforceMaxLength(input1);
          lastFocusedInput = input1;
        }
      });
    });

    // Handle typing/pasting
    ['silicone-text-1', 'silicone-text-2'].forEach(id => {
      const input = document.getElementById(id);
      input.addEventListener('input', function() {
        enforceMaxLength(this);
        this.value = this.value.toUpperCase();
      });
    });

  
}
